module.exports = __webpack_public_path__ + "img/1494935318.bded2553.jpg";